import React from 'react';
import { T as Typography } from './Typography-BUVIUAC9.js';

function Text({ variation = "default", size = "base", align = "start", children, maxLines = "unlimited", }) {
    const textColors = {
        default: "text",
        subdued: "textSecondary",
        success: "success",
        error: "critical",
        warn: "warning",
        info: "informative",
        disabled: "disabled",
    };
    const maxLineToNumber = {
        single: 1,
        small: 2,
        base: 4,
        large: 8,
        larger: 16,
        unlimited: undefined,
    };
    return (React.createElement(Typography, { textColor: textColors[variation], size: size, numberOfLines: maxLineToNumber[maxLines], align: align }, children));
}

export { Text as T };
